<button
  class="group -me-2 hidden h-12 place-items-center gap-2 rounded-full pe-2 ps-4 md:flex dark:hover:bg-white/10 [&.open]:bg-[#F3F0F4] dark:[&.open]:text-[#1E1E1E]"
  type="button"
  #trigger="cdkOverlayOrigin"
  [ngClass]="{ open: isOpen() }"
  [attr.aria-expanded]="isOpen() ? 'true' : 'false'"
  [attr.aria-controls]="isOpen() ? 'headernav-panel' : null"
  [attr.aria-label]="languageService.currentLanguage().name?.substring(0, 2)"
  (click)="isOpen.set(!isOpen())"
  matRipple
  cdkOverlayOrigin
>
  @if (languageService.currentLanguage().name) {
    <span>{{ languageService.currentLanguage().name.substring(0, 2) }}</span>
  }
  <span class="flex h-6 w-6 place-content-center place-items-center transition-transform group-[.open]:rotate-180">
    <sheba-arrow-down-icon />
  </span>
</button>

<ng-template
  #overlay="cdkConnectedOverlay"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'center',
      originY: 'bottom',
      overlayX: 'center',
      overlayY: 'top'
    }
  ]"
  [cdkConnectedOverlayScrollStrategy]="blockScrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="['opacity-1']"
  [cdkConnectedOverlayDisableClose]="false"
  (detach)="isOpen.set(false)"
  (overlayOutsideClick)="isOpen.set(false)"
  cdkConnectedOverlay
>
  <div
    class="m-4 hidden overflow-hidden rounded-3xl bg-white shadow-xl md:flex"
    @openClose
    [cdkTrapFocusAutoCapture]="true"
    (backdropClick)="isOpen.set(false)"
    cdkTrapFocus
  >
    <div class="flex flex-col">
      @if((this.bilingualPaths && this.bilingualPaths.englishPath && this.bilingualPaths.hebrewPath) || this.contentType == "doctorPage" ) {
        @for (lang of languageService.languagesList(); track $index) {
          <button
            [shebaGtmEvent]="{ event: 'switch_language' }"
            [shebaGtmClick]="{ user_action: 'user_switch_language_' + lang.isoCode }"
            (click)="languageService.setLanguage(lang); isOpen.set(false)"
            shButton
            medium
            color="black"
          >
            {{ lang.name }}
          </button>
        }
      }
      @else {
          <button
            [shebaGtmEvent]="{ event: 'switch_language' }"
            [shebaGtmClick]="{ user_action: 'user_switch_language_' + this.languageService.currentLanguage().isoCode }"
            (click)="languageService.setLanguage(this.languageService.currentLanguage()); isOpen.set(false)"
            shButton
            medium
            color="black"
          >
            {{ this.languageService.currentLanguage().name }}
          </button>
      }
      
    </div>
  </div>
</ng-template>
